import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { PageOrdenTrabajoDTO } from "../../interfaces/page-orden-de-trabajo.interface";
import { environment as ENV } from "environments/environment";
import { DetalleOrdenTrabajoDTO } from "../../interfaces/detalle-orden-trabajo.interface";
import { AvanceTrabajoDTO } from "../../interfaces/avance-trabajo.interface";
import { InvitacionesDTO } from "../../interfaces/invitacion-trabajo.interface";
import { InvitacionTrabajoDTO } from "../../models/invitacion-trabajo.model";
import { map } from "rxjs/operators";
import { PlazoDTO } from "../../models/plazo.model";
import { FiltrosService } from "../util/filtros.service";

const API = "oott";
@Injectable({
    providedIn: "root",
})
export class OrdenesDeTrabajoService {
    oottsChanged$: Subject<PageOrdenTrabajoDTO>;
    refreshOOTT$: Subject<boolean>;
    oottsRefresh$: BehaviorSubject<boolean>;
    oottsInvitacionesRefresh$: BehaviorSubject<boolean>;

    private paginaActual: number;
    private cantidaResultadosPorPagina: number;
    private campoOrden: string;
    private orden: string;
    private totalDeResultados: number;
    private cantidadPaginas: number;
    constructor(private http: HttpClient, private _filtros: FiltrosService) {
        this.oottsChanged$ = new Subject();
        this.refreshOOTT$ = new Subject();
        this.oottsRefresh$ = new BehaviorSubject(null);
        this.oottsInvitacionesRefresh$ = new BehaviorSubject(null);

        this.resetPaginador();
    }

    resetPaginador() {
        this.paginaActual = 0;
        this.cantidaResultadosPorPagina = 10;
        this.totalDeResultados = 0;
        this.cantidadPaginas = 0;
        this.campoOrden = "fecha";
        this.orden = "desc";
    }

    fetchOOTT(): Observable<PageOrdenTrabajoDTO> {
        const filtrosOOTT = this._filtros.getFiltro("filtrosOOTT");

        //console.log(filtrosOOTT);

        //console.log("filtrosOOTT.nroTicket[0].valor");
        //console.log(filtrosOOTT.nroTicket[0].valor);

        let parametros: string = "";
        parametros +=
            filtrosOOTT.idCliente[0].valor > 0
                ? "&idCliente=" + filtrosOOTT.idCliente[0].valor
                : "";
        parametros +=
            filtrosOOTT.nroTicket[0].valor > 0
                ? "&ticket=" + filtrosOOTT.nroTicket[0].valor
                : "";
        parametros +=
            filtrosOOTT.estadoOOTT[0].valor !== 0
                ? "&estado=" + filtrosOOTT.estadoOOTT[0].valor
                : "";
        parametros +=
            filtrosOOTT.situacion[0].valor > 0
                ? "&situacion=" + filtrosOOTT.situacion[0].valor
                : "";
        parametros +=
            filtrosOOTT.estadoPago[0].valor > 0
                ? "&pagoTrabajo=" + filtrosOOTT.estadoPago[0].valor
                : "";

        //console.log("url");
        //console.log(
        //    `${ENV.apiUrl}${API}?page=${this.paginaActual}&size=${this.cantidaResultadosPorPagina}${parametros}&sort=${this.campoOrden},${this.orden}`
        //);

        return this.http.get<PageOrdenTrabajoDTO>(
            `${ENV.apiUrl}${API}?page=${this.paginaActual}&size=${this.cantidaResultadosPorPagina}${parametros}&sort=${this.campoOrden},${this.orden}`
        );
    }

    fetchDetalleOrdenTrabajo(
        idOOTT: number
    ): Observable<DetalleOrdenTrabajoDTO> {
        return this.http
            .get<DetalleOrdenTrabajoDTO>(`${ENV.apiUrl}${API}/${idOOTT}`)
            .pipe(
                map((detalleOT) => {
                    if (detalleOT.trabajo) {
                        detalleOT.trabajo.contratista.evaluacion =
                            detalleOT.trabajo.contratista.evaluacion =
                                parseFloat(
                                    detalleOT.trabajo.contratista.evaluacion.toFixed(
                                        1
                                    )
                                );
                    }
                    return detalleOT;
                })
            );
    }

    fetchAvanceTrabajo(idTrabajo: number): Observable<AvanceTrabajoDTO[]> {
        return this.http
            .get<AvanceTrabajoDTO[]>(
                `${ENV.apiUrl}${API}/trabajo/${idTrabajo}/avances`
            )
            .pipe(
                map((avances) => {
                    avances.forEach((avance) => {
                        const datosPersonaRecibe =
                            avance.descripcion.split("-");
                        if (datosPersonaRecibe.length === 3) {
                            let rut = datosPersonaRecibe[1];
                            let resto = datosPersonaRecibe[2].split("|");
                            let dv = resto[0];
                            let nombre = resto[1];
                            if (rut && dv && nombre) {
                                avance.rutPersona = rut + "-" + dv;
                                avance.nombrePersona = nombre;
                            }
                            const posicion = avance.descripcion.indexOf("-");
                            if (posicion !== -1) {
                                avance.descripcion = avance.descripcion.substr(
                                    0,
                                    posicion
                                );
                            }
                        }
                    });
                    return avances;
                })
            );
    }

    comprarServicio(
        idServicio: number,
        ticket?: string
    ): Observable<DetalleOrdenTrabajoDTO> {
        let path = `${ENV.apiUrl}${API}/${idServicio}`;
        if (ticket) {
            path = path + `?ticket=${ticket}`;
        }

        return this.http.post<DetalleOrdenTrabajoDTO>(path, null);
    }

    generaInvitacionesContratistas(
        idOOTT: number,
        invitacionTrabajo: InvitacionTrabajoDTO
    ) {
        return this.http.post<DetalleOrdenTrabajoDTO>(
            `${ENV.apiUrl}${API}/invitacion/${idOOTT}`,
            invitacionTrabajo
        );
    }

    fetchInvitacionTrabajo(idOOTT: number): Observable<InvitacionesDTO[]> {
        return this.http
            .get<InvitacionesDTO[]>(`${ENV.apiUrl}${API}/invitacion/${idOOTT}`)
            .pipe(
                map((invitaciones) => {
                    invitaciones.map((invitacion) => {
                        invitacion.vigente =
                            new Date(invitacion.fechaVigencia) > new Date();
                        invitacion.contratista.evaluacion =
                            invitacion.contratista.evaluacion = parseFloat(
                                invitacion.contratista.evaluacion.toFixed(1)
                            );
                    });
                    return invitaciones;
                })
            );
    }

    anularOOTT(idOOTT: number): Observable<string> {
        return this.http.patch<string>(
            `${ENV.apiUrl}${API}/${idOOTT}/anular`,
            null
        );
    }

    evaluarTrabajo(idTrabajo: number, evaluacion: number): Observable<string> {
        return this.http.patch<string>(
            `${ENV.apiUrl}${API}/trabajo/${idTrabajo}/evaluar?evaluacion=${evaluacion}`,
            null
        );
    }

    corregirOOTT(idOOTT: number, observaciones: string): Observable<string> {
        return this.http.patch<string>(
            `${ENV.apiUrl}${API}/${idOOTT}/corregir`,
            observaciones
        );
    }

    anularTrabajo(
        idTrabajo: number,
        motivo: string,
        evaluacion: number
    ): Observable<string> {
        let path = `${ENV.apiUrl}${API}/trabajo/${idTrabajo}/anular`;
        if (evaluacion > -1) {
            path = path + `?evaluacion=${evaluacion}`;
        }
        return this.http.patch<string>(path, motivo);
    }

    recibirOOTT(
        idOOTT: number,
        conObs: boolean,
        comentarios: string
    ): Observable<any> {
        return this.http.patch<string>(
            `${ENV.apiUrl}${API}/${idOOTT}/recibir?conObs=${conObs}`,
            comentarios
        );
    }
    asignarContratista(
        idOOTT: number,
        rutContratista: number,
        plazo: PlazoDTO
    ) {
        return this.http.patch<string>(
            `${ENV.apiUrl}${API}/${idOOTT}/asignar/${rutContratista}`,
            plazo
        );
    }

    asignarTicket(idOOTT: number, nroTicket: string): Observable<any> {
        return this.http.patch<string>(
            `${ENV.apiUrl}${API}/${idOOTT}?ticket=${nroTicket}`,
            null
        );
    }

    bajarPdf(idOT: number): Observable<Blob> {
        const requestOptions: Object = {
            responseType: "blob",
        };
        return this.http.get<any>(
            `${ENV.apiUrl}${API}/${idOT}.pdf`,
            requestOptions
        );
    }

    setCampoOrden(campoOrden: string) {
        this.campoOrden = campoOrden;
    }

    getCampoOrden(): string {
        return this.campoOrden;
    }

    setCantidadPaginas(cantidadPaginas: number): void {
        this.cantidadPaginas = cantidadPaginas;
    }

    getCantidadPaginas(): number {
        return this.cantidadPaginas;
    }

    getTotalDeResultados(): number {
        return this.totalDeResultados;
    }

    setTotalDeResultados(totalDeResultados: number): void {
        this.totalDeResultados = totalDeResultados;
    }

    setOrden(orden: string): void {
        this.orden = orden;
    }

    getOrden(): string {
        return this.orden;
    }

    setPaginaActual(pagina: number): void {
        this.paginaActual = pagina;
    }

    getPaginaActual(): number {
        return this.paginaActual;
    }

    setCantidaResultadosPorPagina(cantidadResultados: number): void {
        this.cantidaResultadosPorPagina = cantidadResultados;
    }

    getCantidaResultadosPorPagina(): number {
        return this.cantidaResultadosPorPagina;
    }
}
